import { OPTIONS_PARAM } from "~/components/ui/Product/ProductHeader/_data/constants"
import { applySearchParams } from "~/utils/apply-searchparams"

export function addOptionsParamURLToHref(href: string, options: string) {
  const searchParams = new URLSearchParams()

  searchParams.set(OPTIONS_PARAM, options)

  // I have to replace all commas with %2C because the URLSearchParams API encodes commas as %2C
  return applySearchParams(href, searchParams)?.replaceAll("%2C", ",")
}
